import { render, staticRenderFns } from "./StudentQuerySearchDisplay.vue?vue&type=template&id=ba1bdb2a&"
import script from "./StudentQuerySearchDisplay.vue?vue&type=script&lang=ts&"
export * from "./StudentQuerySearchDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./StudentQuerySearchDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports